<template lang="html">
  <section :id="id" class="custom-display-element-versions">
    <base-card :no-padding="true">
      <template v-slot:header>
        <card-header :header-title="$t('versions')">
          <template v-slot:actions>
            <button
              class="m-button outline-brand"
              @click.stop="toggleNewVersionModal"
            >
              {{ $t("newVersion") }}
            </button>
          </template>
        </card-header>
      </template>
      <table class="m-table bordered no-row-hover striped">
        <thead>
          <tr>
            <th>{{ $t("version") }}</th>
            <th>{{ $t("datePublished") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(version, index) in versions" :key="index">
            <td>
              <div class="truncate">
                <a
                  class="link"
                  @click="
                    goTo(
                      ROUTE_NAMES.customDisplayElementVersionDetails,
                      version.uuid
                    )
                  "
                >
                  {{ version.version }}
                </a>
              </div>
            </td>
            <td>
              <div class="truncate" v-if="version.published">
                <span>{{ version.formattedPublished }}</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </base-card>
    <new-version-custom-display-element-modal
      v-if="displayModal"
      :id="`add-new-custom-display-element-${$route.params.widgetuuid}`"
      :widgetuuid="this.$route.params.widgetuuid"
      :modal-title="$t('newVersion')"
      @on-new-version-close="toggleNewVersionModal"
    />
    <div class="loader-wrap">
      <div class="loader" v-if="displayLoader"></div>
    </div>
  </section>
</template>

<script lang="js">
  import { MUTATION_NAME, TOAST_OPTIONS, ROUTE_NAMES } from "@/static/global-variables";
  import BaseCard from "@/components/card/BaseCard";
  import CardHeader from "@/components/card/CardHeader";
  import DistributionChannelsService from "@/services/distributionChannelsService";
  import NewVersionCustomDisplayElementModal from "@/components/custom-display-elements/modal/NewVersionCustomDisplayElementModal";

  export default  {
    name: "custom-display-element-versions",
    components: {
      BaseCard,
      CardHeader,
      NewVersionCustomDisplayElementModal
    },
    props: {
      id: String
    },
    data () {
      return {
        ROUTE_NAMES,
        displayLoader: false,
        displayModal: false
      }
    },
    computed: {
      messages() {
        return this.$store.state.messages;
      },
      widgetDetail() {
        return this.$store.getters[MUTATION_NAME.WIDGET_VERSIONS] || {};
      },
      versions() {
        return this.isCurrentStoreData? this.widgetDetail.versions : [];
      },
      isCurrentStoreData() {
        return this.widgetDetail.widgetuuid === this.$route.params.widgetuuid;
      }
    },
    mounted () {
      if(!this.isCurrentStoreData) {
        this.displayLoader = true;
        DistributionChannelsService.widgetVersions(this.$route.params.widgetuuid)
        .catch((e) => {
          this.$bvToast.toast(this.getMessageText(this.messages.ERROR_WHILE_LOADING), TOAST_OPTIONS.bottomCenter);
          console.error(e);
        })
        .finally(() => {
          this.displayLoader = false;
        });
      }
    },
    methods: {
      goTo(name, widgetversionuuid) {
        this.$router.push({
          name,
          params: {
            uuid: this.$route.params.uuid,
            widgetuuid: this.$route.params.widgetuuid,
            widgetversionuuid
          }
        });
      },
      toggleNewVersionModal() {
        this.displayModal = !this.displayModal;
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "@/styles/components/main";
  .custom-display-element-versions {
    box-sizing: border-box;
    position: relative;
    .loader-wrap {
      position: absolute;
      top: 4rem;
      width: 100%;
      .loader {
        position: relative;
        margin: auto;
        width: 1.8rem;
        height: 1.8rem;
      }
    }
  }
</style>
